(() => {
    const MODULE_NAME = 'ccpa',
        FEED_HEADER = 'tbl-feed-header',
        CCPA_CLASS = 'tbl-ccpa',
        RIGHT_LOGO_CLASS = 'tbl-logo-right-position',
        CLICK_EVENT = (TRC.Device && TRC.Device.isTouchDevice) ? 'touchstart' : 'click';

    class Ccpa {
        constructor(placementData, publishCardNum, feed) {
            this.feed = feed.container;
            this.publisherCardNum = publishCardNum;
            this.getconfigs();
            this.feedHeader = this.feed.querySelector(`.${FEED_HEADER}`);
            this.createCcpaElement();
            this.setEvents();
        }

        createCcpaElement() {
            const logoPosition = TRC.dom.containsClass(this.feedHeader, RIGHT_LOGO_CLASS) ? 'right' : 'left';
            this.ccpaContainer = `<div  class="${CCPA_CLASS} ${this.getCcpaPositionClass(logoPosition)}">${this.getCcpaText()}</div>`;
            if (this.variant === 'bottom-right') {
                const firstCard = this.feed.querySelector(`div[data-card-index="1"]`),
                    firstCardWrapper = firstCard.querySelector('.trc_rbox');
                firstCard.style.position = 'relative';
                firstCardWrapper.insertAdjacentHTML('afterbegin', this.ccpaContainer);
                return;
            }
            this.feedHeader.insertAdjacentHTML('afterbegin', this.ccpaContainer);
        }

        getCcpaText() {
            return this.variant === 'top-left-long' ? 'Do Not Sell My Info' : 'CCPA Notice';
        }

        getCcpaPositionClass(logoPosition) {
            if (this.variant === 'bottom-right') {
                return 'tbl-ccpa-below';
            }
            if (logoPosition === 'right') {
                return this.variant === 'top-right' ? 'tbl-ccpa-top-close-right' : 'tbl-ccpa-top-far';
            }
            if (logoPosition === 'left') {
                return this.variant === 'top-right' ? 'tbl-ccpa-top-close-left' : 'tbl-ccpa-top-far-right';
            }
        }

        getconfigs() {
            const {options} = TRC.CustomModulesManager.registeredModules[MODULE_NAME];
            this.variant = options.variant || 'top-left'; // Variants: top-left, top-right, bottom-right, top-left-lon
        }

        setEvents() {
            this.ccpaElement = this.feed.querySelector(`.${CCPA_CLASS}`);
            TRC.dom.on(this.ccpaElement, CLICK_EVENT, () => {
                TRCImpl.sendAbTestEvent('ccpa', 'click');
            });
            const observerParams = {
                targetElement: this.ccpaElement,
                onTrigger: Ccpa.observerCallback
            };
            TRC.intersections.isInViewPort(observerParams);
        }

        static observerCallback(element, observer, state) {
            if (state === 1) {
                TRCImpl.sendAbTestEvent('ccpa', 'visible');
            }
        }
    }

    Ccpa.hooks = {
        'after-card-created': function (placementData, publisherCardNum, feed) {
            if (!TRC.createdCppaFeed) {
                new Ccpa(placementData, publisherCardNum, feed);
                TRC.createdCppaFeed = true;
            }
        }
    };
    TRC.customHooks[MODULE_NAME] = Ccpa;
})();